import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Blog.css";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { ContactTextAnimation } from "../../Animations/Animations";
import { Link } from "react-router-dom";
import { getAllBlogs } from "../../lib/firebase/blogs";

const Blog = () => {
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToScroll: 1,
    slidesToShow: 3,
    autoplay: true,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const { ref, inView } = useInView({
    threshold: 0.5,
    triggerOnce: true,
  });

  const [viewDiv, setViewDiv] = useState(false);

  const animation = useAnimation();

  useEffect(() => {
    if (inView) {
      setViewDiv(true);
    }
    if (!inView) {
      setViewDiv(false);
    }
  }, [inView, animation]);

  const blogAnimation = {
    hidden: {
      x: "-100vw",
      opacity: 0,
    },
    visible: {
      x: 0,
      opacity: 1,
      transition: { duration: 1.5, delay: 1.3, type: "spring" },
    },
  };

  const [blogs, setBlogs] = useState([]);
  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const p = await getAllBlogs();
        setBlogs(p);
      } catch (error) {
        console.error("Error fetching blogs:", error);
      }
    };
    fetchBlogs();
  }, [])
const randomBlogs = blogs
  ?.slice()                       // create a shallow copy to avoid mutating the original
  .sort(() => Math.random() - 0.5) // shuffle randomly
  .slice(0, 6);  
  return (
    <>
      {/* Blog Start From Here */}
      <section id="blog" className="container px-6 mx-auto pb-20">
        <motion.h2
          initial="hidden"
          animate={viewDiv && "visible"}
          variants={ContactTextAnimation}
          className="my-12 text-5xl text-center tracking-tight font-extrabold  text-dark dark:text-white sm:leading-none">
          Recent
          <span className="text-indigo-600 dark:text-indigo-500"> Blogs</span>
        </motion.h2>
        <div className="" ref={ref}>
          <Slider {...settings}>
            {
              randomBlogs.map(blog => (
                <motion.div
                  key={blog.id}
                  initial="hidden"
                  animate={viewDiv && "visible"}
                  variants={blogAnimation}
                >
                  <div className="mx-4 rounded-lg shadow single-blog cursor-pointer relative">
                    <Link to={`/blog/${blog.id}`}
                      className="blog-text bg-indigo-900 bg-opacity-80 rounded-lg"
                      rel="noreferrer"
                    >
                      <div className="flex items-center justify-center w-full h-full">
                        <h1 className="text-white text-2xl font-semibold text-center">
                          {blog.title}
                        </h1>
                      </div>
                    </Link>
                    <img
                      src={blog.coverImage}
                      alt="blog"
                      className="blog-image w-full h-72 hidden rounded-lg"
                    />
                  </div>
                </motion.div>
              ))
            }
          </Slider>
        </div>
        <div className="flex items-center justify-center mt-6 py-4">
          <Link to="/all-blog" className="bg-purple-800 text-white py-2 px-4 rounded text-lg hover:bg-purple-700 transition duration-300">
            View More
          </Link>
        </div>

      </section>
    </>
  );
};

export default Blog;
